module.exports = __webpack_public_path__ + "daa2af3a7d57ed882600fac542e0f23b.MP3";